const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function PaymentTestModeBanner() {
  if (!clientToken) {
    return (
      <div className="w-full border-b border-red-300 bg-red-100 px-4 py-2 text-center text-sm text-red-800">
        Pagamentos em produção não estão configurados. Conclua a ativação do Stripe no painel para
        aceitar pagamentos reais.
      </div>
    );
  }
  if (clientToken.startsWith("pk_test_")) {
    return (
      <div className="w-full border-b border-orange-300 bg-orange-100 px-4 py-2 text-center text-sm text-orange-800">
        Pagamentos no preview rodam em modo de teste. Use o cartão 4242 4242 4242 4242 (qualquer
        validade futura, qualquer CVC).
      </div>
    );
  }
  return null;
}
